module.exports = __webpack_public_path__ + "media/images/icons/date-9ad39dc233095f1ce9908a9f1b092f78.svg";